/*
 * @Author: your name
 * @Date: 2021-05-25 11:12:37
 * @Description: In User Settings Edit
 * @FilePath: \mall_pc\src\common\Enum\index.js
 */
import { EnumBase } from './EnumBase'

export const isBool = new EnumBase([
	{ key: 'NO', label: '否', value: 0 },
	{ key: 'YES', label: '是', value: 1 }
])

// 系统类型
export const systemType = new EnumBase([
	{ key: 'JOY_EDIT', label: '心悦尚品', value: 'joyEdit' },
	{ key: 'YOKELLY_CS', label: 'RICA', value: 'yokelly.cs' }
])

// 是否有营业执照
export const HAVE_LICENSE = new EnumBase([
	{ key: 'TRUE', label: '有营业执照', value: '1' },
	{ key: 'FALSE', label: '暂无法提供营业执照', value: '0' }
])


